import Handler from "./../Handler";

class RoomTableStatusHandler extends Handler {
    // roomTableStatus#
    //     {
    //     "roomId": "ROOM123",
    //     "gameDefId": 101,
    //     "tableId": "TABLE456",
    //     "status": "addition"
    //     }
    // Status will be addition/deletion
    execute(data) {
        let receivedData = JSON.parse(data);
        console.log("roomTableStatus received data:", receivedData);
        this.service.processRoomTableStatusData(receivedData);
    }
}

export default RoomTableStatusHandler;